import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { NotFoundComponent } from './components/not-found/not-found.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'lista',
    loadChildren: () => import('./components/listado/listado.module').then(m => m.ListadoModule),
  },
  {
    path: 'iphone-nuevos-olavarria',
    loadChildren: () => import('./components/listado/listado.module').then(m => m.ListadoModule),
    data: { seccion: 'Nuevos' },
  },
  {
    path: 'iphone-usados-olavarria',
    loadChildren: () => import('./components/listado/listado.module').then(m => m.ListadoModule),
    data: { seccion: 'Usados' },
  },
  {
    path: 'accesorios',
    loadChildren: () => import('./components/listado/listado.module').then(m => m.ListadoModule),
    data: { seccion: 'Accesorios' },
  },
  {
    path: 'cotizar',
    loadChildren: () => import('./components/cotizar/cotizar.module').then(m => m.CotizarModule),
  },
  {
    path: 'preguntas-frecuentes',
    loadChildren: () => import('./components/informacion/informacion.module').then(m => m.InformacionModule),
  },
  {
    path: 'reparacion-iphone-olavarria',
    loadChildren: () => import('./components/reparacion/reparacion.module').then(m => m.ReparacionModule),
  },
  {
    path: 'guia-comprar-iphone-olavarria',
    loadChildren: () => import('./components/guia-compra/guia-compra.module').then(m => m.GuiaCompraModule),
  },
  {
    path: 'iphone-usado-olavarria',
    loadChildren: () => import('./components/iphone-usado/iphone-usado.module').then(m => m.IphoneUsadoModule),
  },
  {
    path: 'guias',
    loadChildren: () => import('./components/guia/guia.module').then(m => m.GuiaModule),
  },
  {
    path: 'privacidad',
    loadChildren: () => import('./components/privacidad/privacidad.module').then(m => m.PrivacidadModule),
  },
  {
    path: 'politica-devoluciones',
    loadChildren: () => import('./components/devoluciones/devoluciones.module').then(m => m.DevolucionesModule),
  },
  {
    path: 'admin',
    loadChildren: () => import('./components/admin/admin.module').then(m => m.AdminModule),
  },
  {
    path: 'turno',
    loadChildren: () => import('./components/turno-publico/turno-publico.module').then(m => m.TurnoPublicoModule),
  },
  {
    path: 'mayorista',
    loadChildren: () => import('./components/mayorista-publico/mayorista-publico.module').then(m => m.MayoristaPublicoModule),
  },
  {
    path: 'ig',
    loadChildren: () => import('./components/ig/ig.module').then(m => m.IgModule),
  },
  {
    path: 'cuotas',
    loadComponent: () => import('./components/cuotas/cotizador.component').then(m => m.CotizadorComponent),
  },
  // Cualquier ruta que no matchea ninguna de arriba — server.ts le pone el
  // status 404 real (esto solo cubre qué se ve, no el código HTTP).
  {
    path: '**',
    component: NotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
